import { RefreshCw } from 'lucide-react';
import { Button } from '@/ui/components/ui/button';

interface FRToolbarProps {
	onRefresh: () => Promise<unknown>;
	refreshing: boolean;
}

export function FRToolbar({ onRefresh, refreshing }: FRToolbarProps) {
	return (
		<div className='flex items-center gap-2 mb-4'>
			<h2 className='text-base font-semibold text-foreground'>
				Feature requests
			</h2>
			<Button
				type='button'
				variant='ghost'
				size='sm'
				onClick={onRefresh}
				disabled={refreshing}
				className='h-7 w-7 p-0'
			>
				<RefreshCw
					className={`size-3.5 ${refreshing ? 'animate-spin' : ''}`}
				/>
			</Button>
		</div>
	);
}
